module.exports = __webpack_public_path__ + "static/img/fire.2c87793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fire.png
// module id = dPCe
// module chunks = 1